export const ONESIGNAL_APP_ID = '69fdaad8-02e4-4a6a-9206-65da6a983347';
export const ONESIGNAL_SAFARI_WEB_ID = 'web.onesignal.auto.5d56d362-2565-48e1-9c7d-b5c325eeeb04';
